import { render } from "./RedpackLeftBottom.vue?vue&type=template&id=c522f9cc&scoped=true&ts=true"
import script from "./RedpackLeftBottom.vue?vue&type=script&lang=ts"
export * from "./RedpackLeftBottom.vue?vue&type=script&lang=ts"

import "./RedpackLeftBottom.vue?vue&type=style&index=0&id=c522f9cc&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c522f9cc"]])

export default __exports__